export default function ContactHero() {
  return (
    <section className="contact-banner-hero" data-testid="contact-hero">
      <div className="contact-banner-wrap">
        <img 
          src="/images/contactus_hero.webp" 
          alt="Contact Sairaksha Dairy Products - Get in touch with our team" 
          className="contact-hero-img"
          loading="eager"
        />
      </div>
    </section>
  );
}
